var S = Object.defineProperty;
var b = (r, e, t) => e in r ? S(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var o = (r, e, t) => b(r, typeof e != "symbol" ? e + "" : e, t);
import { i as R, A as l } from "./abort.js";
import { o as w } from "./helpers.js";
import { S as v } from "./sentry.js";
function U(r, e = []) {
  const t = new URLSearchParams(r), s = {};
  for (const a of t.keys())
    s[a] = e.includes(a) ? t.getAll(a) : t.get(a);
  return s;
}
function O(r) {
  return Object.getPrototypeOf(r) === Object.prototype;
}
function x(r) {
  if (!r)
    return;
  const e = w(r, [
    "query",
    "body",
    "response",
    "retry",
    "onProgress"
  ]), t = r == null ? void 0 : r.body;
  return t ? O(t) || Array.isArray(t) ? { ...e, body: JSON.stringify(t), headers: A(e == null ? void 0 : e.headers) } : { ...e, body: t } : e;
}
function A(r) {
  return E(r, { "Content-Type": "application/json" });
}
function E(...r) {
  const e = new Headers();
  for (const t of r)
    for (const [s, a] of new Headers(t).entries())
      e.set(s, a);
  return e;
}
function H(r) {
  const e = _(r).toString();
  return e ? `?${e}` : "";
}
function _(r) {
  const e = new URLSearchParams();
  for (const t in r) {
    const s = r[t], a = Array.isArray(s) ? s : [s];
    for (const n of a)
      n !== void 0 && e.append(t, n.toString());
  }
  return e;
}
async function j(r) {
  var e;
  try {
    return r.status === 204 ? void 0 : (e = r.headers.get("Content-Type")) != null && e.includes("application/json") ? await r.json() : await r.text();
  } catch (t) {
    throw R(t) ? new l(t.message) : t;
  }
}
async function N(r) {
  try {
    return j(r);
  } catch (e) {
    if (l.is(e))
      throw e;
    return;
  }
}
const u = "__fetch_error__";
var d, f, h;
class i extends (h = Error, f = u, d = v, h) {
  constructor(t, s = "UNKNOWN", a) {
    super(`Fetch error: ${s} ${t}${a ? `. ${a}` : ""}`);
    o(this, f, !0);
    o(this, d, !1);
    this.url = t, this.method = s;
  }
  static is(t) {
    return t instanceof i || !!t && typeof t == "object" && u in t;
  }
  static fromFetch(t, s, a) {
    const n = a instanceof Error ? a.message : void 0;
    return new i(t, (s == null ? void 0 : s.method) ?? "GET", n);
  }
}
const y = "__api_error__";
var m, p;
class c extends (p = i, m = y, p) {
  constructor(t, s, a = "GET") {
    super(t.url, a, `APIError ${t.status} ${t.statusText}`);
    o(this, m, !0);
    this.response = t, this.body = s;
  }
  static is(t) {
    return t instanceof c || !!t && typeof t == "object" && y in t;
  }
  static async fromResponse(t, s) {
    const a = await N(t);
    return new c(t, a, s);
  }
}
function I(r) {
  return r != null && r.retry ? { ...r.retry === !0 ? {} : r.retry, signal: r == null ? void 0 : r.signal } : void 0;
}
export {
  c as A,
  i as F,
  A as a,
  H as b,
  _ as c,
  j as d,
  N as e,
  I as f,
  x as g,
  O as i,
  E as m,
  U as p
};
//# sourceMappingURL=requestHelpers.js.map
